import { useQuery } from '@tanstack/react-query';
import { COMPANY_BUSINESS_UNITS_KEY } from 'src/utils/constants/queryKeys';
import { getBusinessUnits } from '../services/fn-api/Company';

export const useGetCompanyBusinessUnits = (companyId: number) => {
  return useQuery({
    queryKey: [COMPANY_BUSINESS_UNITS_KEY, companyId],
    queryFn: () => getBusinessUnits(companyId),
    enabled: !!companyId,
  });
};
